import { UserForegroundDomainEnum } from './user-foreground-domain-enum'

export interface QuizReflectionBlockInterface {
  /**
   * 活动任务 ID
   */
  activityTaskId: number
  /**
   * 试卷 ID
   */
  quizId: number
  /**
   * 试卷 ID
   */
  paperId: number
  rid: number
  reflectionDomain?: UserForegroundDomainEnum
  /**
   * 题目块 ID
   */
  blockIds: number[]
  isLatestVersion?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class QuizReflectionBlock implements QuizReflectionBlockInterface {
  /**
   * 活动任务 ID
   */
  activityTaskId: number
  /**
   * 试卷 ID
   */
  quizId: number
  /**
   * 试卷 ID
   */
  paperId: number
  rid: number
  reflectionDomain?: UserForegroundDomainEnum
  /**
   * 题目块 ID
   */
  blockIds: number[]
  isLatestVersion?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: QuizReflectionBlockInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      activityTaskId: _activityTaskId,
      quizId: _quizId,
      paperId: _paperId,
      rid: _rid,
      reflectionDomain: _reflectionDomain,
      blockIds: _blockIds,
      isLatestVersion: _isLatestVersion,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.activityTaskId = _activityTaskId
    this.quizId = _quizId
    this.paperId = _paperId
    this.rid = _rid
    this.reflectionDomain = _reflectionDomain
    this.blockIds = _blockIds
    this.isLatestVersion = _isLatestVersion
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
